import React from "react";
import { Stack, Avatar, Box, Typography, Checkbox } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useHistory } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockIcon from "@mui/icons-material/Lock";
import SortIcon from "@mui/icons-material/Sort";
import { Images } from "./../../assets/common";
import { useDispatch } from "react-redux";
import { addSongAction } from "./../../action/songs";
import { fullName } from "../../constants/function";
import PlayIcon from "../icons/PlayIcon";
export default function MusicRow({
  isHistory,
  isPrivate,
  handleOpen,
  isCheckbox,
  isPlay,
  music,
  onChecked,
  isChecked,
  index,
  onClick,
  play,
  onRedirect,
  playSongs,
  playingIndex,
  disabled,
}) {
  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();
  const [checked, setChecked] = React.useState(isChecked ? isChecked : false);
  const handleCheck = (e) => {
    setChecked(!checked);
    onChecked(music["_id"], e, index);
  };
  const playSong = () => {
    if (music["fileId"]) {
      playSongs();
    }
    //  dispatch(addSongAction(music));
  };
  const redirectToArtist = (music) => {
    if (music["creatorId"])
      onRedirect(`/app/ArtistProfile/${music["creatorId"]}`);
    else if (music["creaedBy"])
      onRedirect(`/app/ArtistProfile/${music["creaedBy"]}`);
    else if (music["uploader"] && typeof music["uploader"] === "string")
      onRedirect(`/app/ArtistProfile/${music["uploader"]}`);
    else if (music["uploader"] && typeof music["uploader"] === "object")
      onRedirect(`/app/ArtistProfile/${music["uploader"]["_id"]}`);
    else if (music["owner"] && typeof music["owner"] === "string")
      onRedirect(`/app/ArtistProfile/${music["owner"]}`);
    else if (music["owner"] && typeof music["owner"] === "object")
      onRedirect(`/app/ArtistProfile/${music["owner"]["_id"]}`);
  };
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      className="_cp"
    >
      <Stack
        direction="row"
        alignItems="center"
        width="90%"
        onClick={() => (onClick ? onClick() : null)}
      >
        <Box mr={2}>
          <Box sx={{ position: "relative" }} className="__player_queue_image">
            <Avatar
              src={
                music["thumbnailImg"]["filePath"]
                  ? music["thumbnailImg"]["filePath"]
                  : Images.rectangle
              }
            />
            {play ? (
              <PlayIcon
                onClick={() => playSong()}
                className="_play_queue_play"
                sx={{ fontSize: 20 }}
              />
            ) : (
              false
            )}
          </Box>
        </Box>
        <Box sx={{ marginRight: "auto" }}>
          <Stack>
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                variant="body1"
                className="fs-14 _cp"
                onClick={() => onRedirect(`/app/SongDetails/${music["_id"]}`)}
              >
                {music["title"] ? music["title"] : ""}
              </Typography>
              {music["private"] ? (
                <LockIcon
                  sx={{ width: "16px", height: "16px", padding: "3px" }}
                  className="__small_icon"
                />
              ) : null}
            </Stack>

            <Stack
              direction="row"
              style={{
                overflowY: "scroll",
                width: music["artistData"]?.length > 2 ? "225px" : "",
                gap: "5px",
              }}
              className="scroll_display_musicCard"
            >
              {music["artistData"] ? (
                music["artistData"].length > 1 ? (
                  music["artistData"].map((a, index) => (
                    <Typography
                      variant="body2"
                      className="fs-13 fade-text _cp"
                      onClick={() =>
                        history.push(`/app/ArtistProfile/${a.uId}`)
                      }
                      key={index}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {a?.displayArtistName}
                      {music["artistData"].length - 1 == index ? "" : ","}
                    </Typography>
                  ))
                ) : (
                  music["artistData"].map((a, index) => (
                    <Typography
                      variant="body2"
                      className="fs-13 fade-text _cp"
                      onClick={() =>
                        history.push(`/app/ArtistProfile/${a.uId}`)
                      }
                      key={index}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {a?.displayArtistName}
                    </Typography>
                  ))
                )
              ) : (
                <Typography
                  variant="body2"
                  className="fs-13 fade-text _cp"
                  onClick={() => {
                    redirectToArtist(music);
                  }}
                >
                  {music["artist"] ? music["artist"] : ""}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Box>
      </Stack>
      {isCheckbox ? (
        <Checkbox
          icon={<RadioButtonUncheckedIcon />}
          checkedIcon={<CheckCircleIcon />}
          color="primary"
          checked={checked}
          disabled={disabled && !checked}
          onChange={(e) => handleCheck(e.target.checked)}
          className={disabled && !checked ? " _notAllowed" : ""}
        />
      ) : (
        <Stack direction="row" spacing={2}>
          {isHistory ? (
            <ArrowForwardIosIcon color="default" sx={{ fontSize: "16px" }} />
          ) : (
            <>
              {
                play &&
                music["track"] &&
                !music["track"].paused &&
                playingIndex === index ? (
                  <img
                    style={{ width: "14px" }}
                    src={Images.listen}
                    alt="listen"
                  />
                ) : null
                // <AddIcon color="default" />
              }
              <MoreVertIcon
                onClick={() => handleOpen(true)}
                sx={{
                  color: theme.palette.primary.main,
                  backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.mode === "light" ? 0.1 : 0.25
                  ),
                  borderRadius: "50%",
                  padding: "2px",
                }}
              />
            </>
          )}
        </Stack>
      )}
    </Stack>
  );
}
